import {FC, useEffect} from "react";
import {Col, Container, Row, Table} from "react-bootstrap";
import "../../../App.css";
import {
    timeDiffToString,
    timeToString,
} from "../../tools";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {selectPrintCalendarEvent, setPrintCalendarEvent} from "../../../features/AppStateSlice";
import {RRCalendarDayType} from "../../types/RRCalendarDayType";

interface Props {
    window: any;
}

const PrintEventDayProtocolFrame: FC<Props> = ({window}) => {
    const fontSize = "8pt";
    const dispatch = useAppDispatch();
    const event = useAppSelector(selectPrintCalendarEvent);

    useEffect(() => {
        const onAfterPrint = () => { dispatch(setPrintCalendarEvent(null)) }
        window.addEventListener('afterprint', onAfterPrint);
        return () => {
            window.removeEventListener('afterprint', onAfterPrint)
        }
    }, []);

    useEffect(() => {
        if (event) { window.print() }
    }, [event]);

    if (!event || !event.event) return null;

    let total = 0;
    return <>
        <Container fluid className={"print-content"}>
            <Row>
                <Col className={"border border-2 border-dark text-center p-2"} style={{fontSize: "14px"}}>
                    <Row>
                        <Col className={"text-start ps-3"}>
                            Дата: <strong>{ event.calendarDay.date }</strong>
                        </Col>
                        <Col className={"text-start ps-3"}>
                            Събитие: <strong>{ event.event.eventNumber }</strong>
                        </Col>
                        <Col className={"text-start ps-3"}>
                            Място: <strong>{ event.event.place }</strong>
                        </Col>
                        <Col className={"text-start pe-5"} xs={"4"}>
                            Подпис отговорник събитие:
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className={"mt-3"}>
                <Table bordered style={{fontSize: fontSize}}>
                    <thead>
                    <tr className={"text-center"}>
                        <th>#</th>
                        <th>Име</th>
                        <th>Начало</th>
                        <th>Край</th>
                        <th>Почивка</th>
                        <th>Часове</th>
                        <th>Подпис</th>
                        <th>Забележки</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        event.items.map(
                            (item: RRCalendarDayType, idx: number) => {
                                return (
                                    <tr key={item.id}>
                                        <td className={"w-30px text-end"}> { (idx + 1) } </td>
                                        <td className={"w-160px"}> { item.employeeName } </td>
                                        <td className={"w-50px text-center"}> { timeToString(item.eventDayStart) } </td>
                                        <td className={"w-50px text-center"}> { timeToString(item.eventDayEnd) } </td>
                                        <td className={"w-50px text-center"}> { item.restTime } </td>
                                        <td className={"w-50px text-center"}> { timeDiffToString(item.eventDayStart, item.eventDayEnd, item.restTime || 0)} </td>
                                        <td className={"w-75px"}></td>
                                        <td></td>
                                    </tr>
                                );
                            }
                        )
                    }
                    </tbody>
                </Table>
            </Row>

                <Row className={"mt-5"}>
                    <Col>
                        Дата на подаване: <br/><br/>
                        Подпис приел: ......................................................
                    </Col>
                    <Col className={"text-end"} xs={"auto"}>
                        Име и подпис на отговорника склад: ...............................................................................................
                    </Col>
                </Row>
        </Container>
    </>
}

export default PrintEventDayProtocolFrame;
